import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.insertDataUserRegistration.pageTitle',
    defaultMessage: 'Inserisci dati',
    description: 'Title of the insert data user registration page',
  },
  pageSubtitle: {
    id: 'features.insertDataUserRegistration.pageSubtitle',
    defaultMessage: 'Inserisci i tuoi dati nei campi obbligatori',
    description: 'Subtitle of the insert data user registration page',
  },
  buttonInserDataUserRegistration: {
    id: 'features.insertDataUserRegistration.buttonInserDataUserRegistration',
    defaultMessage: 'Avanti',
    description: 'Label of the insert data user registration button',
  },
  backTo: {
    id: 'features.insertDataUserRegistration.backTo',
    defaultMessage: 'Indietro',
    description: 'Disclaimer "back to"',
  },
  labelUserCodeInputText: {
    id: 'features.insertDataUserRegistration.labelUserCodeInputText',
    defaultMessage: 'Codice utente',
    description: 'Label of user code input text',
  },
  placeholderUserCodeInputText: {
    id: 'features.insertDataUserRegistration.placeholderUserCodeInputText',
    defaultMessage: 'Inserisci il tuo codice utente',
    description: 'Placeholder of user code input text',
  },
  labelFiscalCodeInputText: {
    id: 'features.insertDataUserRegistration.labelFiscalCodeInputText',
    defaultMessage: 'Codice fiscale',
    description: 'Label of fiscal code input text',
  },
  placeholderFiscalCodeInputText: {
    id: 'features.insertDataUserRegistration.placeholderFiscalCodeInputText',
    defaultMessage: 'Inserisci il tuo codice fiscale',
    description: 'Placeholder of fiscal code input text',
  },
  labelVatCodeInputText: {
    id: 'features.insertDataUserRegistration.labelVatCodeInputText',
    defaultMessage: 'Partita IVA / Codice fiscale',
    description: 'Label of P.IVA input text',
  },
  placeholderVatCodeInputText: {
    id: 'features.insertDataUserRegistration.placeholderVatCodeInputText',
    defaultMessage: 'Inserisci la tua Partita IVA / Codice fiscale',
    description: 'Placeholder of P.IVA input text',
  },
  labelOnlyVatCodeInputText: {
    id: 'features.insertDataUserRegistration.labelOnlyVatCodeInputText',
    defaultMessage: 'Partita IVA',
    description: 'Label of P.IVA input text',
  },
  placeholderOnlyVatCodeInputText: {
    id: 'features.insertDataUserRegistration.placeholderOnlyVatCodeInputText',
    defaultMessage: 'Inserisci la tua Partita IVA',
    description: 'Placeholder of P.IVA input text',
  },
});
